import { ExcludedPlatforms } from 'app/types/excludedPlatforms'
import { ColorEnum } from 'app/utils/mapColors'
import { gql } from 'graphql-request'

import { GenericBlock } from './generic'

export const productGridFragment = gql`
  fragment productGridFragment on ProductGrid {
    id
    title
    titleHighlight
    ctaLabel
    ctaHref
    products {
      id
      title
      description
      price
      discount
      href
      ctaLabel
      backgroundColour
      image {
        id
        url
      }
    }
    excludedPlatforms {
      ios
      android
      web
    }
  }
`

export interface ProductGrid extends GenericBlock<'ProductGrid'> {
  title?: string
  titleHighlight?: string
  ctaLabel?: string
  ctaHref?: string
  products: {
    id: string
    title?: string
    description?: string
    price: number
    discount?: number
    href: string
    ctaLabel?: string
    backgroundColour?: ColorEnum
    image: {
      id: string
      url: string
    }
  }[]
  excludedPlatforms: ExcludedPlatforms
}
